<template>
    <a-button @click="validate" class="ant_btn_orange" :disabled="!enableClick">{{enableClick ? defaultTitle : countDown + countTitle}}</a-button>
</template>

<script>
export default {
    name: 'ThrottleBtn',
    props: {
        defaultTitle: {
            type: String,
            required: false,
            default: '短信验证码'
        },
        countTitle: {
            type: String,
            required: false,
            default: '秒后可以重新发送'
        },
        imgCode: {
            type: String,
            default: ''
        },
        mobile: {
            type: String,
            default: ''
        },
        email:{
          type: String,
          default: ''
        },
        type: {
            type: String,
            default: ''
        },
        time: {
            type: Number,
            required: false,
            default: 60,
        },
        isValidate: {
            type: Boolean,
            required: false,
            default: false
        },
        typeValue:{
          type: String,
        }
    },
    data () {
        return {
            enableClick: true,
            countDown: 60,
            clock: 0,
            code: '',
            tel: ''
        }
    },
    methods: {
        validate () {
            if (this.isValidate) {
                this.$emit('validate')
            } else {
                this.sendSms();
            }
        },
        handleClick () {
          if (!this.enableClick) return

          var _this = this;

          _this.enableClick = false;
          _this.clock = setInterval(() => {
            --_this.countDown
            if (_this.countDown === 0) {
              clearInterval(_this.clock)
              _this.enableClick = true
              _this.countDown = _this.time
            }
          }, 1000)
        },
        sendSms () {
              if (!this.enableClick) return

              var _this = this;
              if(_this.typeValue=='mobile'){
                _this.$util.api('/sms',{
                  mobile: _this.tel,
                  code: _this.code
                },function(res){
                  if(res.code == 10000 && _this.tel==res.data){
                    _this.enableClick = false;
                    _this.clock = setInterval(() => {
                      --_this.countDown
                      if (_this.countDown === 0) {
                        clearInterval(_this.clock)
                        _this.enableClick = true
                        _this.countDown = _this.time
                      }
                    }, 1000)
                  }else{
                    _this.$message.error(res.msg);
                  }
                });
              }else if(_this.typeValue=='email'){
                _this.$util.api('/email/code',{
                  email: _this.email,
                },function(res){

                  if(res.code == 10000 && _this.email==res.data){
                    _this.enableClick = false;
                    _this.clock = setInterval(() => {
                      --_this.countDown
                      if (_this.countDown === 0) {
                        clearInterval(_this.clock)
                        _this.enableClick = true
                        _this.countDown = _this.time
                      }
                    }, 1000)
                  }else{
                    _this.$message.error(res.msg);
                  }
                });
              }
          },
          cancel () {
              clearInterval(this.clock);
              this.clock = 0;
              this.time = 60;
              this.enableClick = true;
          }
    },
    watch: {
        time: {
            handler (time) {
                this.countDown = time;
            },
            immediate: true
        },
        imgCode: {
            handler (val) {
                this.code = val;
            },
            immediate: true
        },
        mobile: {
            handler (val) {
                this.tel = val;
            },
            immediate: true
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/ThrottleBtn.vue